"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDebuff = void 0;
const __1 = require("../..");
const enums_1 = require("../enums");
const Effects_1 = require("../../metadata/Effects");
const DefaultArgs = {
    supernatural: false,
    onApplied: () => { },
    onResisted: (sequence, args) => {
        sequence.push(new __1.FloatingTextVfxStepArgs("Resisted", new __1.ActorVfxLocationSelector(args.targetId, "head")));
    }
};
function applyDebuff(args) {
    // TODO: Evaluate safety of this.
    // if(this.isDeceased(args.targetId)) {
    //   return
    // }
    args = {
        ...DefaultArgs,
        ...args
    };
    const { attackerId, targetId, effect, duration, supernatural, hidden, onApplied, onAppliedOrResisted } = args;
    let { sequence } = args;
    sequence = args.sequence.pushSequence("sequential");
    const debuffId = this.applyEffect(sequence, attackerId, targetId, effect, duration, supernatural);
    // linked effects are always hidden
    if (!hidden && effect.__typeName !== "LinkedEffects") {
        sequence = sequence.pushSequence("parallel");
        const [text, color] = (0, Effects_1.printEffect)("apply", effect, targetId, this);
        const appliedOrResisted = text;
        if (appliedOrResisted) {
            duration.type !== enums_1.DurationType.Instant && sequence.push(new __1.BattleLogEntryVfxStepArgs([
                __1.BattleLogEntrySegment.actorName(this, targetId),
                new __1.BattleLogEntrySegment(appliedOrResisted, color),
            ]));
            sequence.push(new __1.FloatingTextVfxStepArgs(appliedOrResisted, new __1.ActorVfxLocationSelector(targetId, "random"), color, "small"));
            sequence.push(new __1.EffectApplyVfxStepArgs(debuffId, new __1.ActorVfxLocationSelector(targetId), text, color));
        }
    }
    const cb = onApplied;
    cb(sequence, args);
    onAppliedOrResisted === null || onAppliedOrResisted === void 0 ? void 0 : onAppliedOrResisted(sequence, args, true);
    return debuffId;
}
exports.applyDebuff = applyDebuff;
